/**
 * @file Research And Development Master View.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { renderRoutes } from 'react-router-config';

const propTypes = {
  route: PropTypes.object,
};

const RndMasterView = ({ route }) => {
  return <Fragment>{renderRoutes(route.routes)}</Fragment>;
};

RndMasterView.propTypes = propTypes;

export default RndMasterView;
